import { LoadingOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import AnimatingDots from '~/components/AnimatingDots';
import Background from '~/components/Background';
import Button from '~/components/Button';
import Cardbox from '~/components/Cardbox';
import Divider from '~/components/Divider';
import Gap from '~/components/Gap';
import PasswordInput from '~/components/PasswordInput';
import Text from '~/components/Text';
import { LOGIN_ROUTE } from '~/constants/routes';
import { useResetPassword } from './useResetPassword';
import { useIsDesktop } from '~/hooks/useIsDesktop';

const ResetPassword = () => {
  const { msg, isLoading, isValid, password, setPassword, isSubmitted, handleSubmit } =
    useResetPassword();
  const navigate = useNavigate();
  const isDesktop = useIsDesktop();

  const handleLoginRedirect = () => {
    navigate(LOGIN_ROUTE);
  };

  return (
    <>
      {isValid && !isSubmitted && (
        <Background key="resetpassword" data-component-name="ResetPassword">
          <div className="full-view-dimensions center">
            <Cardbox>
              <Text align="center" size={isDesktop ? 'lg' : 'md'} className="bold">
                Enter your new password
              </Text>
              <Gap t={24} />
              <Text>Enter your new password below.</Text>
              <Gap t={32} />
              <Text size="xs">Password</Text>
              <Gap t={6} />
              <PasswordInput
                placeholder="**************"
                value={password}
                onChange={e => {
                  setPassword(e.target.value);
                }}
              />
              <Gap t={24} />
              <Button disabled={isLoading || !password.trim()} size="full" onClick={handleSubmit}>
                {isLoading ? <LoadingOutlined /> : 'Submit'}
              </Button>
            </Cardbox>
          </div>
        </Background>
      )}
      {(!isValid || isSubmitted) && (
        <div className="full-view-dimensions v-center">
          {isLoading ? <AnimatingDots /> : <Text size="md">{msg}</Text>}
          <Gap t={24} />

          <Divider margin="32px 0" />
          <div className="full-width v-center spread align-center">
            <Button onClick={handleLoginRedirect} variant="secondary">
              Log in
            </Button>
          </div>
        </div>
      )}
    </>
  );
};

export default ResetPassword;
